import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Section } from 'components/BusinessCard/components/StyledComponents'
import ensureHttp from 'modules/link'

import { useBusinessCard } from 'components/BusinessCard/context'
import { P, H6, Link } from '@PipelineDeals/shared-react-components'

const Website = ({ websiteAttrs }) => {
  const { t } = useTranslation()
  const { cardMeta: { showOnlyFields }, resource, resourceType } = useBusinessCard()

  const websites = useMemo(() => {
    return websiteAttrs.filter(attr => showOnlyFields.includes(attr)).map(attr => resource[attr]).filter(attr => !!attr)
  }, [websiteAttrs, showOnlyFields, resource])

  if (!websites.length) return null

  return (
    <div data-cypress={`${resourceType}-business-card-website`}>
      {websites.map(website =>
        <Section key={website}>
          <H6>{t('businessCard.labels.website')}</H6>
          <Link href={ensureHttp(website)} target="_blank" rel="noopener noreferrer">
            <P>{website}</P>
          </Link>
        </Section>
      )}
    </div>
  )
}

Website.propTypes = {
  websiteAttrs: PropTypes.array.isRequired
}

export default Website
